import { Directive, ElementRef } from '@angular/core';
declare let $: any;
@Directive({
    selector: '[appHotspotDrag]',
    standalone: false
})
export class HotspotDragDirective {

  constructor(private el: ElementRef) { 
    let domElement:any;
    domElement = el.nativeElement as HTMLElement;
    $(domElement).draggable({
      helper: 'clone',
      zIndex: 1000
  });
  }

}
